import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ITrainingType } from '../../../message-models/training-record-type.interface';
import { DynamicDialogRef, DynamicDialogConfig} from "primeng/dynamicdialog";
import { TrainingRecord } from '../../../domain-model/training-record.class';
import { HelpConsts } from "../../../help/models/help-consts";

@Component({
  selector: 'app-training-record-editor-modal',
  templateUrl: './training-record-editor-modal.component.html',
  styleUrls: ['./training-record-editor-modal.component.scss']
})

export class TrainingRecordEditorModalComponent implements OnInit {
  @Input() heading = 'Training Record Editor';
  @Input() editing = false;
  @Input() trainingRecord: TrainingRecord;
  @Input() isMultipleOperatives: boolean = false;
  @Input() trainingTypes: ITrainingType[] = [];
  @Output() saveTrainingRecordClicked: EventEmitter<TrainingRecord> = new EventEmitter<TrainingRecord>();
  @Output() saveNewTrainingRecordDocumentRequested: EventEmitter<TrainingRecord> = new EventEmitter<TrainingRecord>();
  @Output() cancelTrainingRecordClicked: EventEmitter<string> = new EventEmitter<string>();
  @Output() saveNewTrainingRecordTypeRequested: EventEmitter<ITrainingType> = new EventEmitter<ITrainingType>();
  addingNewTrainingType: boolean = false;
  saveAttempted: boolean = false;
  showingHelp: boolean = false;
  helpAlertText: string = HelpConsts.TrainingRecordHelp.sections[0].body;

  constructor(public modalRef: DynamicDialogRef, public config: DynamicDialogConfig) {
  }

  ngOnInit(): void {
    if (this.config.data) {
      this.heading = this.config.data.heading;
      this.trainingRecord = this.config.data.trainingRecord;
      this.editing = this.config.data.editing;
    }
  }

  saveTrainingRecord() {
    this.saveAttempted = true;
    if (!this.trainingRecord.isValid) {
      return;
    }

    this.saveAttempted = false;

    this.modalRef.close();

    let newTrainingRecord = new TrainingRecord(this.trainingRecord);
    this.saveTrainingRecordClicked.emit(newTrainingRecord);
  }

  editTrainingRecord() {
    this.editing = true;
  }

  cancelClicked() {
    this.cancelTrainingRecordClicked.emit(null);
    this.modalRef.close();
  }

  saveNewTrainingTypeRequested(trainingType: ITrainingType) {
    this.saveNewTrainingRecordTypeRequested.emit(trainingType);
  }

  addNewTrainingTypeRequested(isAdding: boolean) {
    this.addingNewTrainingType = isAdding;
  }

  helpClicked() {
    this.showingHelp = !this.showingHelp;
  }

  saveAndUploadDocument() {

    this.saveAttempted = true;

    if (!this.trainingRecord.isValid) {
      return;
    }

    this.saveAttempted = false;

    this.modalRef.close();

    let newTrainingRecord = new TrainingRecord(this.trainingRecord);
    this.saveNewTrainingRecordDocumentRequested.emit(newTrainingRecord);
  }

  hideHelpAlert() {
    this.showingHelp = false;
  }
}
